const Skills = [
    'JavaScript',
    'TypeScript',
    'React',
    'Redux',
    'Node.js',
    'Express.js',
    'MySQL',
    'Mongoose/MongoDb',
    'HTML5',
    'CSS3',
    'ASP.NET Core',
    'Entity Framework Core',
    'C#',
    'Git',
    'Java',
    'Spring Boot',
    'Spring Security',
    'Spring Data JPA',
    'Docker',
    'AWS (S3, EC2, RDS, etc.)'
];

export default Skills;